import { Link } from "react-router-dom";

export default function CTABand({ variant = "default" }) {
  const isDark = variant === "dark";
  const bg = isDark ? "bg-acoe-charcoal" : "bg-acoe-paper";
  const textColor = isDark ? "text-acoe-bg" : "text-acoe-charcoal";
  const mutedColor = isDark ? "text-white/60" : "text-acoe-text";

  return (
    <section className={`${bg} py-20 md:py-28`} data-testid="cta-band">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
        <p className={`text-sm tracking-widest uppercase font-heading font-semibold ${isDark ? "text-acoe-gold" : "text-acoe-muted"} mb-4`}>
          Contact
        </p>
        <h2 className={`font-heading font-bold text-2xl md:text-4xl ${textColor} mb-4`}>
          まずは気軽にお話ししませんか？
        </h2>
        <p className={`text-base ${mutedColor} mb-10 max-w-xl mx-auto`}>
          ACOEの事業やポジションについて、カジュアルにお話しできればと思います。採用プラットフォームからお問い合わせください。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/recruit/contact"
            className={`inline-flex items-center justify-center rounded-full px-8 py-4 font-heading font-semibold tracking-wide transition-colors duration-300 ${
              isDark
                ? "bg-acoe-gold text-acoe-charcoal hover:bg-acoe-gold-hover"
                : "bg-acoe-charcoal text-acoe-bg hover:bg-acoe-gold"
            }`}
            data-testid="cta-band-primary"
          >
            お問い合わせ方法を見る
          </Link>
          <Link
            to="/recruit/careers"
            className={`inline-flex items-center justify-center rounded-full px-8 py-4 font-heading font-semibold tracking-wide border transition-all duration-300 ${
              isDark
                ? "border-white/30 text-acoe-bg hover:bg-white/10"
                : "border-acoe-charcoal text-acoe-charcoal hover:bg-acoe-charcoal hover:text-acoe-bg"
            }`}
            data-testid="cta-band-secondary"
          >
            募集要項を見る
          </Link>
        </div>
      </div>
    </section>
  );
}
